
import React from 'react';
import { motion } from 'framer-motion';
import { SERVICES, getIcon, WHATSAPP_URL } from '../constants';

const Services: React.FC = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 }
  };

  return (
    <section id="services" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-[10px] font-bold text-avus-blue uppercase tracking-[0.3em] mb-3">Service Excellence</h2>
          <h3 className="text-2xl md:text-4xl font-bold text-avus-navy mb-4 tracking-tight">Core Competencies</h3>
          <p className="text-base md:text-lg text-slate-500 max-w-xl mx-auto font-medium">
            Strategic support structures designed for Qatar’s unique business environment.
          </p>
        </div>

        <motion.div 
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
        >
          {SERVICES.map((service, index) => (
            <motion.div 
              key={index} 
              variants={item}
              className="bg-slate-50 p-6 md:p-8 rounded-[1.5rem] md:rounded-[2rem] border border-slate-100 hover:border-avus-light hover:bg-white hover:shadow-xl transition-all duration-300"
            >
              <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-5 text-avus-blue">
                {getIcon(service.icon, 24)}
              </div>
              <h4 className="text-lg md:text-xl font-bold text-avus-navy mb-2 tracking-tight">{service.title}</h4>
              <p className="text-[13px] md:text-sm text-slate-500 mb-5 leading-relaxed font-medium">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.subItems.map((sub, idx) => (
                  <li key={idx} className="flex items-center text-[9px] md:text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                    <span className="w-1.5 h-1.5 rounded-full bg-avus-blue/40 mr-2"></span>
                    {sub}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        <div className="mt-16 md:mt-20 bg-avus-navy rounded-[1.5rem] md:rounded-[3rem] p-8 md:p-12 text-center text-white relative overflow-hidden">
          <div className="relative z-10">
            <h3 className="text-xl md:text-3xl font-bold mb-4 tracking-tight">Partnering for the Long Term.</h3>
            <p className="text-slate-400 max-w-xl mx-auto mb-8 text-sm md:text-base font-medium leading-relaxed">
              We provide the foundations that allow Qatari businesses to navigate growth with absolute confidence.
            </p>
            <a 
              href={WHATSAPP_URL} 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-avus-blue text-white px-8 py-3.5 rounded-full font-bold text-sm hover:bg-white hover:text-avus-navy transition-all shadow-lg"
            >
              Request Consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
